import { Button, Container, Header } from '@cloudscape-design/components';
import { getPPartId } from '@parallel-fluidics/shared/models/projects/parts';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import PPartContent from './pPartContent';
import PPartDetailProvider, { usePPartDetail } from './providers/pPartDetailProvider';

function PageLayout() {
  const navigate = useNavigate();
  const { pPart, project, projectDocId } = usePPartDetail();
  return (
    <Container
      header={(
        <Header
          variant="awsui-h1-sticky"
          // Lots only exist for internal projects — no link on customer ones.
          actions={project?.isInternal && (
            <Button
              onClick={() => navigate(`/lots?projectDocId=${projectDocId}&pPartDocId=${pPart.id}`)}
            >
              View lots
            </Button>
          )}
        >
          {getPPartId(pPart)}
        </Header>
      )}
    >
      <PPartContent pPart={pPart} projectDocId={projectDocId} />
    </Container>
  );
}

export default function PPartDetailPage() {
  return (
    <PPartDetailProvider>
      <PageLayout />
    </PPartDetailProvider>
  );
}
